import { useCallback } from 'react';
import { Dashboard, DealOwner, DealSource } from '../types/files';

const useBackwardsCompatible = () => {
  const dashboardWorkspaces = useCallback((dashboard?: Dashboard): string[] =>
    dashboard?.workspaceMemberships?.map(ws => ws.workspaceId) ?? dashboard?.workspaces ?? []
  , []);

  const dashboardOwner = useCallback((dashboard?: Dashboard): DealOwner|undefined =>
    dashboard?.dealOwner ?? (!!dashboard?.userId ? ({email: dashboard?.userId, name: null} as DealOwner) : undefined)
  , []);

  const dashboardSource = useCallback((dashboard?: Dashboard): DealSource|undefined =>
    dashboard?.dealSource ?? (!!dashboard?.source ? ({email: null, name: dashboard?.source} as DealSource) : undefined)
  , []);

  return { dashboardWorkspaces, dashboardOwner, dashboardSource };
};

export default useBackwardsCompatible;
